import { createBindingContext, IEntity } from "@odata/BindingContext";
import { expandEnumProps } from "@odata/Data.utils";
import { EntitySetName, IUserEntity, OdataActionName } from "@odata/GeneratedEntityTypes";
import { ODataQueryResult, parseError } from "@odata/ODataParser";
import { invitationMailPath } from "@pages/payroll/employee/SendInvitation.def";
import { isObjectEmpty } from "@utils/general";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import DialogFormView from "../../../views/formView/DialogFormView";
import { getAlertFromError } from "../../../views/formView/Form.utils";
import { IFormStorageSaveResult } from "../../../views/formView/FormStorage";

class SendInvitationFormView extends DialogFormView<IEntity> {
    save = async (): Promise<IFormStorageSaveResult> => {
        const { storage } = this.props;
        const validationRes = await storage.validateAll();
        if (validationRes.hasError) {
            storage.refresh();
            return null;
        }
        const emailBc = storage.data.bindingContext.navigate(invitationMailPath);
        const email = storage.getValue(emailBc);
        try {
            const res = await storage.oData.getEntitySetWrapper(EntitySetName.PrEmployees).action(
                OdataActionName.PrEmployeeInviteToCustomerPortal,
                this.entity.Id,
                { Email: email }
            ) as ODataQueryResult<IUserEntity>;

            if (!isObjectEmpty(res.value)) {
                const user = res.value;
                expandEnumProps(user, createBindingContext(EntitySetName.Users, storage.oData.metadata));
                this.props.onAfterConfirm(user);
            }
        } catch (e) {
            const error = parseError(e);
            const errorAlert = getAlertFromError(error);
            storage.setFormAlert(errorAlert);

        }
        return null;
    };
}

export default withPermissionContext(SendInvitationFormView);